<div class="p-mobile-friendly animate-fade-in">
  @if (scannerEnabled) {
    <div class="col-12 text-center mb-2">
      <h1 class="text-2xl md:text-3xl font-bold animate-slide-up">Scan Agenda Code</h1>
      <p class="text-color-secondary">Hold the QR code in front of the camera</p>
    </div>

    <div class="col-12 md:col-8 md:col-offset-2 lg:col-6 lg:col-offset-3">
      <div class="card-modern p-5">
        <div class="text-center mb-3">
          <div class="text-sm text-color-secondary mb-2 font-semibold">
            <i class="pi pi-camera mr-1"></i>
            {{ currentCameraName }}
          </div>
          <div class="flex justify-content-center gap-2">
            <p-button (onClick)="onRotate()" icon="pi pi-sync" label="Rotate Camera" class="p-button-outlined btn-modern"></p-button>
            @if (!environment.production) {
              <p-button (onClick)="onScanTest()" icon="pi pi-bolt" label="Test Scan" class="p-button-outlined btn-modern"></p-button>
            }
          </div>
        </div>
        <div class="scanner-container border-round shadow-soft overflow-hidden">
          <zxing-scanner
            #scanner
            (camerasFound)="onCamerasFound($event)"
            (camerasNotFound)="onCamerasNotFound()"
            (scanError)="onScanError()"
            (scanFailure)="onScanFailure($event)"
            (scanSuccess)="onScanSuccess($event)"
            [device]="mediaDeviceInfoList[mediaDeviceInfoIndex]"
          ></zxing-scanner>
        </div>
      </div>
      @if ((checkInOutput?.checked_in_users_in_agenda_count ?? agendaData?.checked_in_users_in_agenda_count) !== undefined) {
        <div class="text-center">
          <span class="inline-flex align-items-center bg-primary-100 text-primary-700 px-3 py-2 border-round-lg mt-3">
            <i class="pi pi-users mr-2"></i>
            Check-in count: {{ checkInOutput?.checked_in_users_in_agenda_count ?? agendaData?.checked_in_users_in_agenda_count }}
          </span>
        </div>
      }
    </div>
  }

  @if (operationInProgress) {
    <div class="col-12">
      <p-progressBar [style]="{ height: '6px' }" mode="indeterminate"></p-progressBar>
    </div>
  }

  @if (!scannerEnabled) {
    <div class="col-12 md:col-8 md:col-offset-2 lg:col-6 lg:col-offset-3">
      <div class="card-modern p-5 text-center animate-scale-in">
        <div class="flex justify-content-center mb-4">
          @if (checkInOutput?.user_not_in_event || checkInOutput?.user_not_in_agenda) {
            <!-- Yellow warning badge for user not in agenda -->
            <div class="check-status-badge warning animate-scale-in">
              <i class="pi pi-exclamation-triangle text-3xl"></i>
            </div>
          } @else if (errorMessage) {
            <!-- Red error badge -->
            <div class="check-status-badge error animate-scale-in">
              <i class="pi pi-times-circle text-3xl"></i>
            </div>
          } @else if (checkInOutput?.agenda_already_checked_in) {
            <!-- Info badge for already checked in -->
            <div class="check-status-badge info animate-scale-in">
              <i class="pi pi-info-circle text-3xl"></i>
            </div>
          } @else {
            <!-- Green success badge -->
            <div class="check-status-badge success animate-scale-in">
              <i class="pi pi-check-circle text-3xl"></i>
            </div>
          }
        </div>
        @if (checkInOutput?.agenda_already_checked_in) {
          <h2 class="text-2xl font-bold mb-3 text-primary">Already Checked In</h2>
        } @else if (errorMessage) {
          <h2 class="text-2xl font-bold mb-3 text-red-600">{{ errorMessage }}</h2>
        } @else if (checkInOutput?.user_not_in_event || checkInOutput?.user_not_in_agenda) {
          <h2 class="text-2xl font-bold mb-3 text-yellow-600">
            {{ checkInOutput?.user_not_in_event ? 'User Not in Event' : 'User Not in Agenda' }}
          </h2>
        } @else {
          <h2 class="text-2xl font-bold mb-3 text-green-600">Check-in Successful</h2>
        }

        @if (checkInOutput?.user; as user) {
          <div class="user-info mb-4">
            <h3 class="text-3xl font-bold mb-2">{{ user?.name || '' }} {{ user?.surname || '' }}</h3>
            @if (user?.job_title || user?.corporation) {
              <div class="text-xl text-color-secondary">
                @if (user?.job_title) {
                  <div>{{ user.job_title }}</div>
                }
                @if (user?.corporation) {
                  <div>{{ user.corporation }}</div>
                }
              </div>
            }
          </div>
        }

        @if (checkInOutput; as data) {
          <div class="stats-container">
            <div class="stat-item mb-3">
              <div class="text-lg font-semibold text-color-secondary">Event Capacity</div>
              <div class="text-2xl font-bold">{{ data.checked_in_users_in_event_count }} / {{ data.users_in_event_count }}</div>
            </div>

            <div class="stat-item mb-3">
              <div class="text-lg font-semibold text-color-secondary">Agenda Capacity</div>
              <div class="text-2xl font-bold">{{ data.checked_in_users_in_agenda_count }} / {{ data.users_in_agenda_count }}</div>
            </div>

            @if (data.table_number || data.seat_number) {
              <div class="flex justify-content-center gap-4 mt-4">
                @if (data.table_number) {
                  <div class="seat-info">
                    <i class="pi pi-table text-2xl mb-1"></i>
                    <div class="text-sm text-color-secondary">Table</div>
                    <div class="text-xl font-bold">{{ data.table_number }}</div>
                  </div>
                }
                @if (data.seat_number) {
                  <div class="seat-info">
                    <i class="pi pi-user text-2xl mb-1"></i>
                    <div class="text-sm text-color-secondary">Seat</div>
                    <div class="text-xl font-bold">{{ data.seat_number }}</div>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
      @if (groupInformation.length > 0) {
        <div class="group-badges mt-4">
          <div class="card-modern p-4">
            <div class="flex flex-wrap justify-content-center gap-3">
              @for (group of groupInformation; track group) {
                <span class="badge-pill">
                  {{ group.name }}
                </span>
              }
            </div>
          </div>
        </div>
      }

      <div class="flex justify-content-center gap-3 mt-5 mb-5">
        <p-button (onClick)="onNewScan()" label="New Scan" icon="pi pi-camera" class="p-button-lg btn-modern"></p-button>
        @if (checkInOutput?.user_not_in_event || checkInOutput?.user_not_in_agenda) {
          <p-button
            (onClick)="onAuthorize()"
            label="Authorize"
            icon="pi pi-check"
            class="p-button-lg p-button-warning btn-modern"
          ></p-button>
        }
      </div>
    </div>
  }
</div>
